import {
    ChatAltIcon,
    ChevronRightIcon,
    CogIcon,
    HeroRectangleGroupIcon,
    HeroShieldCheckIcon,
    HeroUserGroupIcon,
    NinchatQueueIcon,
    NinchatQueuesListIcon,
    TagIcon,
    UsersIcon,
} from 'components/Icon/Icon'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import React from 'react'
import {RouteParamsList} from 'navigation/types'

import {chevronWrapper} from '../styles/Menubar'
import {navigation} from 'navigation'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledChevronWrapper = styled('div', chevronWrapper)

export const DefaultMenuBarOrganizationDashboard = (props: {params: RouteParamsList['Realm']} & {realmId: string}) => {
    const {
        params, realmId,
    } = props
    const {t} = useTranslation()

    const showMembers = params.tab === 'members'
    const showQueues = params.tab === 'queues'
    const showSites = params.tab === 'sites'
    const showSettings = params.tab === 'settings'
    const showCannedMessages = params?.tab === 'canned-messages'
    const showChannels = params.tab === 'channels'
    const showTags = params.tab === 'tags'
    const showPermissions = params.tab === 'permissions'
    const showGroupQueues = params.tab === 'group-queues'

    return (
        <>
            {
                showMembers ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={UsersIcon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'members',
                            })}
                            text={t('Members')}
                        />
                    </>
                    : null
            }
            {
                showQueues ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={NinchatQueueIcon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'queues',
                            })}
                            text={t('Queues')}
                        />
                    </>
                    : null
            }
            {
                showGroupQueues ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={NinchatQueuesListIcon as unknown as Icon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'group-queues',
                            })}
                            text={t('Group Queues')}
                        />
                    </>
                    : null
            }
            {
                showChannels ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={HeroUserGroupIcon as unknown as Icon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'channels',
                            })}
                            text={t('Channels')}
                        />
                    </>
                    : null
            }
            {
                showPermissions ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={HeroShieldCheckIcon as unknown as Icon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'permissions',
                            })}
                            text={t('Permission groups')}
                        />
                    </>
                    : null
            }
            {
                showSites ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={HeroRectangleGroupIcon as unknown as Icon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'sites',
                            })}
                            text={t('Sites')}
                        />
                    </>
                    : null
            }
            {
                showTags ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={TagIcon as unknown as Icon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'tags',
                            })}
                            text={t('Tags')}
                        />
                    </>
                    : null
            }
            {
                showSettings ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={CogIcon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'settings',
                            })}
                            text={t('Settings')}
                        />
                    </>
                    : null
            }
            {
                showCannedMessages ?
                    <>
                        <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                        <Button
                            color='text'
                            iconLeft={ChatAltIcon}
                            onPress={() => navigation.push('Realm', {
                                realm_id: realmId,
                                tab: 'canned-messages',
                            })}
                            text={t('Canned messages')}

                        />
                    </>
                    : null
            }
        </>
    )
}
